import {Injectable} from '@angular/core';
import { HttpEvent, HttpHeaders, HttpRequest, HttpResponse, HttpInterceptor, HttpHandler } from '@angular/common/http';

import {Observable, of} from 'rxjs';
import {startWith, tap} from 'rxjs/operators';

import {RequestCache, RequestCacheWithMap} from '../services/request-cache-with-map.service';


/**
 * If request is cachable (e.g., package search) and
 * response is in cache return the cached response as observable.
 * If has 'x-refresh' header that is true,
 * then also re-run the package search, using response from next(),
 * returning an observable that emits the cached response first.
 *
 * If not in cache or not cachable,
 * pass request through to next()
 */
@Injectable(    { providedIn: 'root'})
export class CachingInterceptor implements HttpInterceptor {
    constructor(private cache: RequestCacheWithMap) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        // continue if not cachable.
        console.log(req.url)
        if (!isCachable(req)) {
            return next.handle(req);
        }

        const cachedResponse = this.cache.get(req);
        // cache-or-fetch
        return cachedResponse ?
            of(cachedResponse) : sendRequest(req, next, this.cache);
    }
    get(){
        return this.cache;
    }
}


/** Is this request cachable? */
function isCachable(req: HttpRequest<any>) {
    // Only GET requests are cachable
    const cache = req.params.get('cache');
    if (cache) {
        return req.method === 'GET' && cache !== '0';
    }
    return req.method === 'GET';
}

/**
 * Get server response observable by sending request to `next()`.
 * Will add the response to the cache on the way out.
 */
function sendRequest(
    req: HttpRequest<any>,
    next: HttpHandler,
    cache: RequestCache): Observable<HttpEvent<any>> {

    // No headers allowed in npm search request
    const noHeaderReq = req.clone({headers: new HttpHeaders()});

    return next.handle(noHeaderReq).pipe(
        tap(event => {
            // There may be other events besides the response.
            if (event instanceof HttpResponse) {
                cache.put(req, event); // Update the cache.
            }
        })
    );
}


/*
Copyright 2017-2018 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/
